export const INIT = '@analytics/init';
export const ENABLE = '@analytics/enable';
export const DISPOSE = '@analytics/dispose';
